import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AddFeedbackToLogMutation,
  AddFeedbackToLogMutationVariables,
} from "./AddFeedbackToLog.generated";

const ADD_FEEDBACK_TO_LOG: TypedDocumentNode<
  AddFeedbackToLogMutation,
  AddFeedbackToLogMutationVariables
> = gql`
  mutation addFeedbackToLog(
    $userUuid: String
    $noteUuid: String
    $noteType: String
    $rating: String
    $feedback: String
  ) {
    addFeedbackToLog(
      userUuid: $userUuid
      noteUuid: $noteUuid
      noteType: $noteType
      rating: $rating
      feedback: $feedback
    ) {
      ok
    }
  }
`;

export default ADD_FEEDBACK_TO_LOG;
